import presentationTemplateService from '../services/templates/presentation_template.service';
import CreateFileTemplatePage from './CreateFileTemplatePage';
const PresentationTemplatePage = CreateFileTemplatePage({
  service: presentationTemplateService,
  templateType: 'presentation_template',
  fileType: 'pptx'
});
export default PresentationTemplatePage;